<template>
  <div>
    <div>
      HELLO WORLD Safety Oversight Committee
    </div>

  </div>
</template>

<script>

export default {
  name: 'SafetyOversightCommittee',
  components: {

  },
  data () {
    return {

    }
  },
  /// ////
  computed: {

  },
  /// ////
  mounted: function () {

  },
  /// ////
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }

  }
}

</script>
<style>

</style>
